const dataSubscription = () => import(/* webpackChunkName: "academy" */ '@/pages/dataSubscription');
const noboForm = () => import(/* webpackChunkName: "academy" */ '@/pages/dataSubscription/components/noboForm');
const sprForm = () => import(/* webpackChunkName: "academy" */ '@/pages/dataSubscription/components/sprForm');

export default [
  {
    path: 'dataSubscription:is_refresh?',
    name: 'Data Subscription',
    alias: '',
    component: dataSubscription,
  },
  {
    path: 'dataSubscription/noboForm:data_subscription_id?:company_id?:type?',
    name: 'Data Subscription / NOBO Report',
    alias: '',
    component: noboForm,
  },
  {
    path: 'dataSubscription/sprForm:data_subscription_id?:company_id?:have_dtcc?',
    name: 'Data Subscription / DTCC/SPR Report',
    alias: '',
    component: sprForm,
  },
];
